import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import initDatetimepickers = require("../../../assets/js/init/initDatetimepickers");

@Component({
  selector: 'app-datetimepicker',
  templateUrl: './datetimepicker.component.html',
  styleUrls: ['./datetimepicker.component.scss']
})
export class DatetimepickerComponent implements OnInit {

  @Input() title: string;
  @Input() removeLimit: boolean;
  @Output() onSetDate = new EventEmitter<string>();
  date: string;

  constructor() {
  }

  ngOnInit() {
    //  Init Bootstrap Select Picker
    initDatetimepickers(this.removeLimit);
  }

  selectDateFromDTP(date: string) {
    this.onSetDate.emit(date);
  }

  selectDate(date: string) {
    this.date = date;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/datetimepicker/datetimepicker.component.ts